/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Nocollaboratorsresults2Inputs */

const en_settings_collaborators_nocollaboratorsresults2 = /** @type {(inputs: Settings_Collaborators_Nocollaboratorsresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have no collaborators in your workbench`)
};

/**
* | output |
* | --- |
* | "You have no collaborators in your workbench" |
*
* @param {Settings_Collaborators_Nocollaboratorsresults2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_nocollaboratorsresults2 = /** @type {((inputs?: Settings_Collaborators_Nocollaboratorsresults2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Nocollaboratorsresults2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_nocollaboratorsresults2(inputs)
});
export { settings_collaborators_nocollaboratorsresults2 as "settings_collaborators_noCollaboratorsResults" }